module.exports = __webpack_public_path__ + "assets/img/nuosavas-namas-elektrine-slaitiniam-stogui.d12f3346.webp";